module.exports = __webpack_public_path__ + "static/media/addMemTam.3370d141.jpg";